"use client";

import { Box, Grid } from "@radix-ui/themes";
import { H1, H2 } from "@/app/components/atoms/Heading";
import TableOfContents from "@/app/components/atoms/TableOfContents";

import ScholarshipTable from "../components/molecules/Table/ScholarshipTable";
import useWindowSize from "../hooks/useWindowSize";
import Table from "../components/atoms/Table";

const contentItems = [
  { title: "Fixed Wing Basic", id: "scholarships/fixed-wing-basic" },
  { title: "Fixed Wing Advanced", id: "scholarships/fixed-wing-advance" },
  { title: "Air Experience", id: "scholarships/air-experience" },
  { title: "Helicopter", id: "scholarships/helicopter" },
  { title: "Gliding", id: "scholarships/gliding" },
  { title: "Airsports", id: "scholarships/airsports" },
  { title: "Drone", id: "scholarships/drone" },
  { title: "ATPL Theory", id: "scholarships/atpl" },
];

const scholarships = [
    {
    name: "The Honourable Company of Air Pilots",
    link: "https://www.airpilots.org/scholarships/flying-scholarships/",
    fixedWingBasic: true,
    fixedWingAdvance: true,
    airExperience: false,
    helicopter: false,
    gliding: true,
    airsports: false,
    drone: true,
    atpl: true,
  },
  {
    name: "Aerobility",
    link: "https://aerobility.com/scholarships",
    fixedWingBasic: true,
    fixedWingAdvance: false,
    airExperience: true,
    helicopter: false,
    gliding: false,
    airsports: true,
    drone: false,
    atpl: false,
  },
  {
    name: "Air Cadets",
    link: "https://raf.mod.uk/aircadets/",
    fixedWingBasic: true,
    fixedWingAdvance: true,
    airExperience: true,
    helicopter: true,
    gliding: true,
    airsports: true,
    drone: false,
    atpl: false,
  },
  {
    name: "Air League",
    link: "https://airleague.co.uk",
    fixedWingBasic: true,
    fixedWingAdvance: true,
    airExperience: false,
    helicopter: false,
    gliding: true,
    airsports: false,
    drone: true,
    atpl: true,
  },
  {
    name: "British Aerobatic Association",
    link: "https://www.aerobatics.org.uk",
    fixedWingBasic: false,
    fixedWingAdvance: false,
    airExperience: false,
    helicopter: false,
    gliding: false,
    airsports: true,
    drone: false,
    atpl: false,
  },
  {
    name: "British Womens Pilot Association",
    link: "https://bwpa.co.uk/scholarships",
    fixedWingBasic: true,
    fixedWingAdvance: true,
    airExperience: true,
    helicopter: true,
    gliding: true,
    airsports: true,
    drone: false,
    atpl: false,
  },
  {
    name: "British Microlight Aircraft Association",
    link: "https://www.bmaa.org",
    fixedWingBasic: true,
    fixedWingAdvance: false,
    airExperience: true,
    helicopter: false,
    gliding: false,
    airsports: false,
    drone: false,
    atpl: false,
  },
  {
    name: "Cotsworld Airport Scholarships",
    link: "https://www.cotswoldairport.com",
    fixedWingBasic: true,
    fixedWingAdvance: false,
    airExperience: true,
    helicopter: false,
    gliding: false,
    airsports: false,
    drone: false,
    atpl: false,
  },
  {
    name: "Flying Scholarships for Disabled People",
    link: "https://fsdp.co.uk/scholarships/",
    fixedWingBasic: true,
    fixedWingAdvance: false,
    airExperience: true,
    helicopter: false,
    gliding: false,
    airsports: false,
    drone: false,
    atpl: false,
  },
  /*{
    name: "Girls Venture Corps Air Cadets",
    link: "https://gvcac.org.uk",
    fixedWingBasic: true,
    fixedWingAdvance: true,
    airExperience: true,
    helicopter: false,
    gliding: false,
    airsports: false,
    drone: false,
    atpl: false,
  },*/
  {
    name: "Sir Geoffrey de Havilland Flying Scholarship",
    link: "https://coachmakers.co.uk",
    fixedWingBasic: true,
    fixedWingAdvance: true,
    airExperience: false,
    helicopter: false,
    gliding: false,
    airsports: false,
    drone: false,
    atpl: false,
  },
  {
    name: "Helicentre Aviation Academy",
    link: "https://flyheli.co.uk",
    fixedWingBasic: false,
    fixedWingAdvance: false,
    airExperience: false,
    helicopter: true,
    gliding: false,
    airsports: false,
    drone: false,
    atpl: false,
  },
  {
    name: "Launchpoint",
    link: "https://gliding.co.uk",
    fixedWingBasic: false,
    fixedWingAdvance: false,
    airExperience: false,
    helicopter: false,
    gliding: true,
    airsports: false,
    drone: false,
    atpl: false,
  },
  {
    name: "Light Aircraft Association",
    link: "https://lightaircraftassociation.co.uk",
    fixedWingBasic: true,
    fixedWingAdvance: true,
    airExperience: true,
    helicopter: false,
    gliding: false,
    airsports: false,
    drone: false,
    atpl: false,
  },
  {
    name: "Liz Inwood Taildragger Scholarship",
    link: "http://vintageaircraftclub.org.uk",
    fixedWingBasic: false,
    fixedWingAdvance: true,
    airExperience: false,
    helicopter: false,
    gliding: false,
    airsports: false,
    drone: false,
    atpl: false,
  },
  {
    name: "Nick Davidson Memorial Flying Scholarship",
    link: "https://www.totalgiving.co.uk/charity/the-nick-davidson-memorial-flying-scholarship-trust",
    fixedWingBasic: true,
    fixedWingAdvance: true,
    airExperience: false,
    helicopter: false,
    gliding: false,
    airsports: false,
    drone: false,
    atpl: false,
  },
  {
    name: "Royal Aero Club Trust",
    link: "https://www.royalaeroclubtrust.org/bursaries",
    fixedWingBasic: true,
    fixedWingAdvance: true,
    airExperience: true,
    helicopter: true,
    gliding: true,
    airsports: true,
    drone: false,
    atpl: false,
  },
  {
    name: "Royal Aeronautical Society Centennial Scholarship Fund",
    link: "https://aerosociety.com",
    fixedWingBasic: true,
    fixedWingAdvance: false,
    airExperience: false,
    helicopter: false,
    gliding: false,
    airsports: false,
    drone: false,
    atpl: false,
  },
  {
    name: "Rob Wildeboer Scholarship",
    link: "https://www.goodwood.com/flying/flying-school/rob-wildeboer-scholarship/",
    fixedWingBasic: true,
    fixedWingAdvance: true,
    airExperience: false,
    helicopter: false,
    gliding: false,
    airsports: false,
    drone: false,
    atpl: false,
  },
  {
    name: "Royal Navy Gliding Scholarships",
    link: "https://fleetairarmoa.org/faaoa-gliding-aviation-scholarships",
    fixedWingBasic: false,
    fixedWingAdvance: false,
    airExperience: false,
    helicopter: false,
    gliding: true,
    airsports: false,
    drone: false,
    atpl: false,
  },
  /*{
    name: "The Take-Off Scholarship",
    link: "https://take-off.org.uk/scholarships",
    fixedWingBasic: true,
    fixedWingAdvance: false,
    airExperience: false,
    helicopter: false,
    gliding: false,
    airsports: false,
    drone: false,
    atpl: false,
  },*/
  {
    name: "University Air Squadron",
    link: "https://raf.mod.uk/our-organisation/university-air-squadrons",
    fixedWingBasic: true,
    fixedWingAdvance: true,
    airExperience: true,
    helicopter: false,
    gliding: true,
    airsports: true,
    drone: false,
    atpl: false,
  },
];

const scholarshipTypes = [
  {
    key: "fixedWingBasic",
    id: "scholarships/fixed-wing-basic",
    title: "Fixed Wing Basic",
  },
  {
    key: "fixedWingAdvance",
    id: "scholarships/fixed-wing-advance",
    title: "Fixed Wing Advanced",
  },
  {
    key: "airExperience",
    id: "scholarships/air-experience",
    title: "Air Experience",
  },
  { key: "helicopter", id: "scholarships/helicopter", title: "Helicopter" },
  { key: "gliding", id: "scholarships/gliding", title: "Gliding" },
  { key: "airsports", id: "scholarships/airsports", title: "Airsports" },
  { key: "drone", id: "scholarships/drone", title: "Drone" },
  { key: "atpl", id: "scholarships/atpl", title: "ATPL Theory" },
];

export default function Scholarships() {
  const { width } = useWindowSize();

  const sections = scholarshipTypes.reduce<JSX.Element[]>(
    (acc, { key, id, title }) => {
      const filteredScholarships = scholarships.filter(
        (scholarship) => scholarship[key as keyof (typeof scholarships)[0]]
      );
      if (filteredScholarships.length === 0) return acc;
      acc.push(
        <Grid key={key} gap="4">
          <H2 id={id}>{title}</H2>
          <Table scholarshipType={title} scholarships={filteredScholarships} />
        </Grid>
      );
      return acc;
    },
    []
  );

  if (width !== undefined && width < 1024) {
    return (
      <section>
        <Box maxWidth={{ initial: "768px", sm: "672px" }} mx="auto">
          <Grid gap="4">
            <H1 isFirst isExtraMargin>
              Scholarships
            </H1>
            <TableOfContents contentItems={contentItems} />
            {sections}
          </Grid>
        </Box>
      </section>
    );
  } else {
    return (
      <section>
        <Grid gap="3">
          <H1 isCentered isFirst isExtraMargin>
            Scholarships
          </H1>
          <ScholarshipTable scholarships={scholarships} />
        </Grid>
      </section>
    );
  }
}
